// Announcement bar
document.querySelectorAll('.announcement-bar').forEach(bar => {
  bar.addEventListener('click', e => {
    if (e.target.closest('button')) return

    const activeSlide = bar.querySelector('[data-link].is-selected')
    const url = activeSlide?.dataset.link

    if (url) window.location.href = url
  })
})




// Skin Guide
document.addEventListener('click', e => {
  const isSkinBtn = e.target.hasAttribute('data-skin-control');

  if (isSkinBtn) {
    let skinAgeTypes = [];
    
    if(document.querySelector('.skin-guide').dataset.ageTypes){
      skinAgeTypes = JSON.parse(document.querySelector('.skin-guide').dataset.ageTypes)?.filter(e => e.length); // filter empty strings.
    }

    const skinTypes = JSON.parse(document.querySelector('.skin-guide').dataset.skinTypes);
    const skinTypeIndex = parseInt(e.target.dataset.skinTypeIndex);
    const skinTypeEls = document.querySelectorAll(`[data-skin-type-index="${skinTypeIndex}"]`);
    const activeEls = document.querySelectorAll('.skin-guide .active');
    const skinNavPrev = document.querySelector('.skin-guide__nav-arrow-prev');
    const skinNavNext = document.querySelector('.skin-guide__nav-arrow-next');
    const skinTypeIndexPrev = skinTypeIndex === 0 ? skinTypes.length - 1 : skinTypeIndex - 1;
    const skinTypeIndexNext = skinTypeIndex === skinTypes.length - 1 ? 0 : skinTypeIndex + 1;

    activeEls.forEach(el => el.classList.remove('active'));
    skinTypeEls.forEach(el => el.classList.add('active'));
    skinNavPrev.dataset.skinTypeIndex = skinTypeIndexPrev;
    skinNavNext.dataset.skinTypeIndex = skinTypeIndexNext;
    
    skinNavPrev.querySelector('.skin-guide__nav-arrow-text').textContent = skinAgeTypes.length ? skinAgeTypes[skinTypeIndexPrev].replace(/_/g, ' ') : skinTypes[skinTypeIndexPrev].replace(/_/g, ' ');
    skinNavNext.querySelector('.skin-guide__nav-arrow-text').textContent = skinAgeTypes.length ? skinAgeTypes[skinTypeIndexNext].replace(/_/g, ' ') : skinTypes[skinTypeIndexNext].replace(/_/g, ' ');

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const ritualATCAll = document.getElementById('ritual-atc-all');
  const sampleLeftArrow = document.getElementById('left-arrow');
  const sampleRightArrow = document.getElementById('right-arrow');

  if(ritualATCAll){
    ritualATCAll.addEventListener('click', e=> {
      const ritualVariants = ritualATCAll.dataset['ritualVariantId'].split(',');
          
      let formData = {
        'items': ritualVariants.map(variant => {
          return { id: parseInt(variant), quantity: 1}
        })
      };

      // Start loading bar at the top of the page
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      queryAjaxPost('/cart/add.js', JSON.stringify(formData)).then(() => refreshCart());
    });
  }

  if(sampleLeftArrow){
    sampleLeftArrow.addEventListener('click', e => {
      const leftBackground = document.getElementById('arrow-background-left');
      const rightBackground = document.getElementById('arrow-background-right');
      const sampleWindow = document.getElementById('sample-scroll');

      rightBackground.style.display = '';
      sampleWindow.scrollBy({
        left: -109,
        behavior: 'smooth'
      });
      leftBackground.style.display = 'none';

    });
  }
  if(sampleRightArrow){
    sampleRightArrow.addEventListener('click', e => {
      const leftBackground = document.getElementById('arrow-background-left');
      const rightBackground = document.getElementById('arrow-background-right');
      const sampleWindow = document.getElementById('sample-scroll');

      leftBackground.style.display = '';
      sampleWindow.scrollBy({
        left: 109,
        behavior: 'smooth'
      });
      rightBackground.style.display = 'none';

    });
  }
});

// Debounce lock: prevents concurrent ADD requests from racing with each other
// (e.g. rapid double-clicks on the same or different sample buttons), which
// could otherwise add multiple free sample variants to the cart at once.
let isSampleUpdating = false;

document.addEventListener('click', function (event) {
  const target = event.target;

  if (target.matches('.CartSamples button:not(.Button--disabled')) {
    // Ignore clicks while a previous sample update is still in flight
    if (isSampleUpdating) return;

    const cartSamples = target.closest('.CartSamples');
    const sampleVariantIds = cartSamples ? cartSamples.dataset.sampleVariantIds : null;
    const variantToAdd = target.dataset.sampleInCart ? target.dataset.variantId : null;
    const isCheckoutSelector = document.querySelector('.CartSamples').dataset.checkoutSelector;
    const cartSampleButtons = document.querySelectorAll('.CartSamples button');

    // Lock out further clicks until this update finishes, preventing racing
    // requests (the "clicked twice and got two samples" bug).
    isSampleUpdating = true;
    if (isCheckoutSelector) {
      cartSampleButtons.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      })
    }

    return queryAjaxGet('/cart.js')
      .then((response) => updateCart(variantToAdd, sampleVariantIds, response, isCheckoutSelector))
      .then(() => { isSampleUpdating = false; })
      .catch(() => { isSampleUpdating = false; });
  }
});



document.addEventListener('cart:change', e => {
  queryAjaxGet('/cart.js').then((response) => {
      checkSampleCartOfferings(response)
  });
});

// Additional trigger: theme/other apps dispatch cart:refresh on cart updates
document.addEventListener('cart:refresh', e => {
  queryAjaxGet('/cart.js').then((response) => {
    checkSampleCartOfferings(response)
  });
});

// Run on the /cart url to remove free samples
if(window.location.href.includes('.com/cart')){
  queryAjaxGet('/cart.js').then((response) => {
    checkSampleCartOfferings(response)
  });

  // Delayed second pass to catch late-arriving samples (other Apps / native
  // /cart/update.js calls that race with page load or reload).
  setTimeout(() => {
    queryAjaxGet('/cart.js').then((response) => {
      checkSampleCartOfferings(response)
    });
  }, 1500);
}

function checkSampleCartOfferings(cart){
  const samples = document.getElementById('CartSamples');
  if (!samples) return;
  const sampleThreshold = parseInt(samples.dataset.thresholdInCents);
  const sampleVariants = samples.dataset.sampleVariantIds.split(',');
  const sampleItemById = {};
  cart.items.forEach(item => { sampleItemById[item.id.toString()] = item; });

  // Collect which sample variants are currently present in the cart
  const cartSampleVariants = sampleVariants.filter(v => sampleItemById[v]);

  // 1) If the cart total is below the threshold, remove ALL free samples (original behaviour kept)
  if (cart.total_price < sampleThreshold) {
    if (cartSampleVariants.length) {
      const emptySamples = {};
      cartSampleVariants.forEach(v => { emptySamples[v] = 0; });
      queryAjaxPost('/cart/update.js', JSON.stringify({updates: emptySamples})).then(() => {
        refreshCart(false);
      });
    }
    return;
  }

  // 2) Enforce "one sample variant max, quantity of 1" regardless of where the
  //    samples came from (ADD button, native /cart/update.js, other Apps, etc.).
  const updates = {};
  let seenFirst = false;

  cartSampleVariants.forEach(v => {
    const item = sampleItemById[v];
    if (!seenFirst) {
      // Keep the first sample variant but clamp its quantity to 1
      seenFirst = true;
      if (item.quantity > 1) updates[v] = 1;
    } else {
      // Any additional sample variant must be removed
      updates[v] = 0;
    }
  });

  const needUpdate = Object.keys(updates).length > 0;
  if (needUpdate) {
    queryAjaxPost('/cart/update.js', JSON.stringify({updates})).then(() => {
      refreshCart(false);
    });
  }
}

// -----------------------------------------------------------------------------
// Checkout-time enforcement (added layer ONLY; original checkout flow untouched)
// -----------------------------------------------------------------------------
// We do NOT reimplement the checkout jump. We only add a validation step in the
// "submit" event: if the free-sample rule is violated (multiple sample kinds,
// quantity > 1, or samples present below the purchase threshold) we block the
// submit and fix the cart. If everything is valid, we re-trigger the SAME native
// submit with the same checkout submitter, so Shopify's original flow
// (POST /cart -> /checkout) is preserved exactly as before.
let allowNativeCheckoutSubmit = false;

// A cart line counts as a free sample when it is one of the configured sample
// variants OR any $0-priced item. The $0 fallback is required because samples
// can enter the cart outside the configured variant list (auto-GWP gifts,
// direct /cart/add.js API calls) — the theme's Auto-GWP logic detects free
// gifts the exact same way (item.price === 0).
function getFreeSampleItems(cart, sampleVariants) {
  return cart.items.filter(item =>
    sampleVariants.includes(item.variant_id.toString()) || item.price === 0
  );
}

function validateSamplesBeforeCheckout(cart) {
  const samples = document.getElementById('CartSamples');
  if (!samples) return true; // no sample configuration -> allow checkout

  const threshold = parseInt(samples.dataset.thresholdInCents);
  const variants = samples.dataset.sampleVariantIds.split(',');

  const present = getFreeSampleItems(cart, variants);
  if (present.length === 0) return true; // no samples in cart -> nothing to enforce

  const belowThreshold = cart.total_price < threshold;   // samples only when total >= threshold
  const tooManyKinds = present.length > 1;               // only ONE sample kind allowed
  const anyQtyOver = present.some(i => i.quantity > 1);  // quantity must be exactly 1

  const valid = !belowThreshold && !tooManyKinds && !anyQtyOver;
  console.log('[checkout-guard] validate samples:', {
    total: cart.total_price, threshold, belowThreshold,
    tooManyKinds, anyQtyOver, samples: present.map(i => [i.variant_id, i.quantity]), valid,
  });
  return valid;
}

document.addEventListener('submit', async function (event) {
  // Only intercept on the cart page
  if (!window.location.href.includes('.com/cart')) return;

  const form = event.target;
  if (!form) return;

  // Only handle the checkout submit (button[name="checkout"]), or the default
  // form submit which uses the checkout button (e.g. pressing Enter).
  const isCheckoutSubmit = event.submitter
    ? event.submitter.name === 'checkout'
    : !!form.querySelector('[name="checkout"]');
  if (!isCheckoutSubmit) return;

  // If this is our own re-submit after a successful validation, let it pass
  // through natively (preserves Shopify's original checkout flow unchanged).
  if (allowNativeCheckoutSubmit) {
    allowNativeCheckoutSubmit = false;
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  console.log('[checkout-guard] Checkout requested, validating free-sample rule...');
  const cart = await queryAjaxGet('/cart.js');

  if (validateSamplesBeforeCheckout(cart)) {
    console.log('[checkout-guard] Valid, proceeding to checkout.'); // native submit -> /checkout
    allowNativeCheckoutSubmit = true;
    if (form.requestSubmit) {
      // Re-trigger with the same checkout submitter so Shopify sees name=checkout
      form.requestSubmit(event.submitter);
    } else {
      form.submit();
    }
  } else {
    console.warn('[checkout-guard] BLOCKED checkout, clearing ALL free samples first.');
    clearAllSamples(cart);
  }
});

// Remove every free sample from the cart (used on checkout-block, so the
// customer can always proceed with a clean cart regardless of why the sample
// rule was violated). Detection is shared with validateSamplesBeforeCheckout
// (configured sample variants + any $0 item), so samples that entered the cart
// outside the sample collection are removed too.
// /cart/update.js keys `updates` by VARIANT ID (not the cart line-item key).
function clearAllSamples(cart) {
  const samples = document.getElementById('CartSamples');
  if (!samples) return;
  const sampleVariants = samples.dataset.sampleVariantIds.split(',');

  const updates = {};
  getFreeSampleItems(cart, sampleVariants).forEach(item => {
    updates[item.variant_id] = 0;
  });

  const keyCount = Object.keys(updates).length;
  console.warn('[checkout-guard] clearAllSamples: removing', keyCount, 'sample line(s):', updates);
  if (keyCount === 0) return; // nothing free left in the cart
  return sendSampleRemoval(updates);
}

// POST the sample-removal updates, then reload the /cart page so the server
// re-renders it (samples gone; and if the cart is now empty, the native
// "cart empty" state shows). A timeout flushes a reload even if the request
// ever hangs, so the customer is never stuck.
function sendSampleRemoval(updates) {
  let reloaded = false;
  const reload = () => {
    if (reloaded) return;
    reloaded = true;
    if (window.location.pathname === '/cart') {
      console.warn('[checkout-guard] cart now clean, reloading cart page.');
      window.location.reload();
    } else {
      refreshCart(false);
    }
  };
  // Safety net: never leave the page stuck waiting on a hung POST.
  setTimeout(reload, 3000);
  return queryAjaxPost('/cart/update.js', JSON.stringify({updates}))
    .then(() => reload())
    .catch(() => reload());
}

function buildUpdatePayload(variantId, samplesList, cart, addMultiVariants, allowDuplicates) {
  const payload = {
    updates: {}
  };

  if (addMultiVariants) {
    const cartVariantIds = cart.items.map(item => item.id.toString());
    samplesList = samplesList.split(',');
    samplesList.forEach(variantId => {
      if (!cartVariantIds.includes(variantId)) {
        payload.updates[variantId] = 1
      } else if (allowDuplicates) {
        const cartVariant = cart.items.find(item => item.id.toString() === variantId);
        payload.updates[variantId] = cartVariant.quantity + 1;
      }
    });

    return payload;
  }

  if (variantId) {
    payload.updates[variantId] = 1;
  }

  if (samplesList && cart && cart.items) {
    var giftsInCart = 0;
    var removeExisting = false;
    cart.items.forEach(function(item) {
        if (item.variant_id.toString() == variantId) {
            removeExisting = true;
            payload.updates[variantId] = 0;
        }

        if (samplesList.includes(item.variant_id.toString())) {
            giftsInCart = giftsInCart + 1;
        }
    });

    if (giftsInCart > 1) {
        cart.items.forEach(function(item) {
            if (samplesList.includes(item.variant_id.toString())) {
                payload.updates[item.variant_id] = 0;
            }
        });
    }
  }
  return payload;
}

function queryAjaxGet(endpoint) {
  return fetch(endpoint, {
      method: 'GET'
  }).then(function (response) {
      if (response.status === 200) {
          return response.json();
      }
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function queryAjaxPost(endpoint, payload) {
  return fetch(endpoint, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: payload
  }).then(function (response) {
      if (response.status === 200) {
          return response.json();
      }
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function refreshCart(force = true) {
  const isCartPage = window.location.pathname === '/cart';

  const cartButton = document.querySelector('a[aria-controls="cart-drawer"]');
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

  if (cartButton && !cartButton.ariaExpanded) {
    cartButton.click();
    return;
  }

  if (force || !isCartPage) {
    if (!window.__justReloadedCart__) {
      window.__justReloadedCart__ = true;
      window.location.reload();
    }
  }
}

setTimeout(() => {
  window.__justReloadedCart__ = false;
}, 1000);


function updateCart(variantToAdd, sampleVariantIds, response, isCheckout, addMultiVariants = false, allowDuplicates = false) {
  const payload = buildUpdatePayload(variantToAdd, sampleVariantIds, response, addMultiVariants, allowDuplicates);
  queryAjaxPost('/cart/update.js', JSON.stringify(payload)).then(() => {
      if (isCheckout) {
          window.location.href = window.location.href;
      } else {
          refreshCart();
      }
  });
}


// Auto-GWP

// Add auto sample item.
document.addEventListener('cart:change', e => {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', false); // Set the third parameter to false for synchronous request
  xhr.send();

  if (xhr.status === 200) {
    const response = JSON.parse(xhr.responseText);
    const productInfo = document.querySelector('[data-product-data]');

    if(productInfo){
      const productInfoData = JSON.parse(productInfo.dataset.productData);
      const isProductPresentInCart = response.items.some(obj => obj.product_id === productInfoData.id);

      if(isProductPresentInCart){
        const autoSampleProd = document.querySelector('[data-enable-auto-samples]');
        if (autoSampleProd.dataset) {
          const autoSampleIds = autoSampleProd.dataset.autoSampleIds;
          queryAjaxGet('/cart.js').then((response) => updateCart(null, autoSampleIds, response, false, true));
        }
      }
    }
  }
});

document.addEventListener('cart:change', e => {
  const cartItemList = document.querySelector('#cart-drawer');
  const autoSamplesCollection = cartItemList.dataset.autoSamplesCollection;
  const triggerAutoSamplesCollection = cartItemList.dataset.triggerAutoSamplesCollection;
  const enableVariantMetafields = cartItemList.dataset.enableVariantMetafields;

  // Use a synchronous XMLHttpRequest instead of fetch
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', false); // Set the third parameter to false for synchronous request
  xhr.send();

  if (xhr.status === 200) {
    var response = JSON.parse(xhr.responseText);

    let freeGifts = response.items.filter(item => item.price === 0);
    let regularItems = response.items.filter(item => item.price !== 0);
    let regularItemIds = regularItems.map(item => item.id);
    let itemsToRemoveCart = [];

    freeGifts.forEach(freeGift => {
      const parsedAutoSamplesCollection = JSON.parse(autoSamplesCollection);
      const parsedTriggerAutoSamplesCollection = JSON.parse(triggerAutoSamplesCollection);
      const parsedEnableVariantMetafields = JSON.parse(`{${enableVariantMetafields}}`);
      let filteredSimpleAutoSample = [];
      let filteredVariantAutoSample = [];
      let enableSampleIndexed = 'enable-sample-';
      let enableVariantSampleIndexed = 'enable-variant-sample-';

      var freeGiftObjXhr = new XMLHttpRequest();
      freeGiftObjXhr.open('GET', `/products/${freeGift.handle}.js`, false); 
      freeGiftObjXhr.send();


      if (freeGiftObjXhr.status === 200) {
        var freeGiftObj = JSON.parse(freeGiftObjXhr.responseText);
        let freeGiftContainsAutoSample = freeGiftObj.tags.filter(tag => tag.includes('auto-sample-'));
        let freeGiftContainsAutoVariantSample = freeGiftObj.tags.filter(tag => tag.includes('auto-variant-sample-'));

        if (parsedAutoSamplesCollection.length) {
          filteredSimpleAutoSample = parsedAutoSamplesCollection.filter(autoSampleProduct => autoSampleProduct.tags.some(element => element.startsWith('auto-sample-')));
          filteredVariantAutoSample = parsedAutoSamplesCollection.filter(autoSampleProduct => autoSampleProduct.tags.some(element => element.startsWith('auto-variant-sample-')));
        }

        // Check if gift has an auto-sample-{number} tag
        if (freeGiftContainsAutoSample.length && filteredSimpleAutoSample.length) {
          let autoSampleTag = freeGiftObj.tags.filter(tag => tag.startsWith('auto-sample-'));
          let autoSampleTagIndex = autoSampleTag.length ? autoSampleTag[0].match(/\d+/)[0] : '';

          // Add a number to the tag
          if (autoSampleTagIndex !== '') {
              enableSampleIndexed += autoSampleTagIndex;
          }

          if (parsedTriggerAutoSamplesCollection.length) {
              let findTriggerProduct = parsedTriggerAutoSamplesCollection.filter(triggerSample => triggerSample.tags.includes(enableSampleIndexed));
              if(findTriggerProduct.length){
                  if(!regularItemIds.includes(findTriggerProduct[0].variants[0].id)){
                      // Trigger Product found in Collection, but not found in cart - Remmove Product
                      itemsToRemoveCart.push(freeGift);
                  }
              } else {
                  // Can't find Trigger Product - Remove Product
                  itemsToRemoveCart.push(freeGift);
              }
          } else {
              // Trigger Product Collections empty - Remove Product
              itemsToRemoveCart.push(freeGift);
          }
        }

        if (freeGiftContainsAutoVariantSample.length && filteredVariantAutoSample.length) {
          let autoSampleVariantTag = freeGiftObj.tags.filter(tag => tag.startsWith('auto-variant-sample-'));
          let autoSampleVariantTagIndexes = autoSampleVariantTag.length ? autoSampleVariantTag[0].match(/\d+/g) : [];

          if (autoSampleVariantTagIndexes.length) {
              enableVariantSampleIndexed += autoSampleVariantTagIndexes[0];
          }
          
          if (parsedTriggerAutoSamplesCollection.length) {
              let findTriggerProduct = parsedTriggerAutoSamplesCollection.filter(triggerSample => triggerSample.tags.includes(enableVariantSampleIndexed));

              if(findTriggerProduct.length){
                  if(!regularItemIds.includes(findTriggerProduct[0].variants[0].id)){
                      parsedTriggerAutoSamplesCollection.forEach(triggerAutoSample => {
                          if (triggerAutoSample.tags.includes(enableVariantSampleIndexed)) {
                              let isTriggerProductPresent = false;
                              triggerAutoSample.variants.forEach(triggerVariant => {
                                  if (parsedEnableVariantMetafields[triggerAutoSample.id][triggerVariant.id].sample_variant_index == autoSampleVariantTagIndexes[1] && regularItemIds.includes(triggerVariant.id)) {
                                      isTriggerProductPresent = true;
                                  }
                              });
                              if (!isTriggerProductPresent) {
                                  // Trigger Product found in Collection, but not found in cart - Remmove Product
                                  itemsToRemoveCart.push(freeGift);
                              }
                          }
                      });
                  }
              } else {
                  // Can't find Trigger Product - Remove Product
                  itemsToRemoveCart.push(freeGift);
              }

          } else {
              // Trigger Product Collections empty - Remove Product
              itemsToRemoveCart.push(freeGift);
          }
        }
      }
    });

    if (itemsToRemoveCart.length) {
      updateTieredGifts([], itemsToRemoveCart);
    }
  }
});


function updateTieredGifts(giftsToAdd, giftsToRemove) {
  const payload = {
      updates: {}
  };

  giftsToAdd.forEach(gift => {
      payload.updates[gift] = 1;
  });

  if (giftsToRemove.length) {
      giftsToRemove.forEach(gift => {
          payload.updates[gift.variant_id] = 0;
      });
  }
  queryAjaxPost('/cart/update.js', JSON.stringify(payload)).then(() => refreshCart());
}

document.addEventListener('variant:change', function(event) {
  // This blow didn't run because of a type in variant:change

  // const variantContainer = document.querySelector('.ProductForm__Variants');
  // const isEnabledVariantAutoSamples = variantContainer.dataset.enableVariantAutoSamples;
  // const variantMetafields = variantContainer.dataset.variantMetafields;
  // const selectedVariant = event.detail.variant;
  // const currentSampleProductIds = variantContainer.dataset.autoSampleIds.split(',');
  // const convertedVariantMetafields =  JSON.parse(`{${variantMetafields}}`);    
  // const allSampleProductIds = [];
      
  // for(const key in convertedVariantMetafields){
  //     if(convertedVariantMetafields[key].sample_product_id !== null){
  //         allSampleProductIds.push(convertedVariantMetafields[key].sample_product_id.toString())
  //     }
  // }

  // const newSampleIdList = currentSampleProductIds.filter(id => id !== '' && !allSampleProductIds.includes(id.toString()));

  // if(isEnabledVariantAutoSamples === 'true'){
  //     // Add Products
  //     if(convertedVariantMetafields.hasOwnProperty(selectedVariant.id)){
  //         let sampleProductId = convertedVariantMetafields[selectedVariant.id].sample_product_id;
  //         if(sampleProductId !== null){
  //             newSampleIdList.push(sampleProductId)
  //         }
  //     } 
  // }
  // variantContainer.dataset.autoSampleIds = newSampleIdList.join(',');

  const selectedVariant = event.detail.variant;
  updateInstallmentWidgets(selectedVariant);

  const formId = event.target?.getAttribute('id') || event.target?.getAttribute('name');

  if (!selectedVariant) {
    return;
  }

  document.querySelectorAll('sale-price[data-anniversary-sale-price-cents]').forEach((salePrice) => {
    if (formId && salePrice.getAttribute('form') !== formId) {
      return;
    }

    const anniversarySalePriceCents = Number(salePrice.dataset.anniversarySalePriceCents);
    const compareAtPrice = salePrice.parentElement?.querySelector('compare-at-price[data-anniversary-compare-price]');
    const applies = selectedVariant.price > anniversarySalePriceCents;

    if (applies) {
      setPriceText(salePrice, salePrice.dataset.anniversarySalePrice);
      salePrice.classList.add('text-on-sale');

      if (compareAtPrice) {
        let compareAtPriceText = formatMoney(selectedVariant.price);

        if (compareAtPrice.dataset.anniversaryCurrencyCode) {
          compareAtPriceText += ` ${compareAtPrice.dataset.anniversaryCurrencyCode}`;
        }

        setPriceText(compareAtPrice, compareAtPriceText);
        compareAtPrice.hidden = false;
        compareAtPrice.classList.add('line-through');
      }

      return;
    }

    let regularPriceText = formatMoney(selectedVariant.price);

    if (compareAtPrice?.dataset.anniversaryCurrencyCode) {
      regularPriceText += ` ${compareAtPrice.dataset.anniversaryCurrencyCode}`;
    }

    setPriceText(salePrice, regularPriceText);
    salePrice.classList.remove('text-on-sale');

    if (compareAtPrice) {
      if (selectedVariant.compare_at_price > selectedVariant.price) {
        let compareAtPriceText = formatMoney(selectedVariant.compare_at_price);

        if (compareAtPrice.dataset.anniversaryCurrencyCode) {
          compareAtPriceText += ` ${compareAtPrice.dataset.anniversaryCurrencyCode}`;
        }

        setPriceText(compareAtPrice, compareAtPriceText);
        compareAtPrice.hidden = false;
        compareAtPrice.classList.remove('line-through');
      } else {
        compareAtPrice.hidden = true;
        compareAtPrice.classList.remove('line-through');
      }
    }
  });
});

function setPriceText(priceElement, priceText) {
  const label = priceElement.querySelector('.sr-only');

  priceElement.textContent = '';

  if (label) {
    priceElement.appendChild(label);
  }

  priceElement.appendChild(document.createTextNode(priceText));
}

function updateInstallmentWidgets(variant) {
  document.querySelectorAll('.product-info__installments').forEach((installments) => {
    const anniversarySalePrice = Number(installments.dataset.anniversarySalePrice);
    const installmentPrice =
      anniversarySalePrice > 0 && variant?.price > anniversarySalePrice
        ? anniversarySalePrice
        : variant?.price;

    if (!installmentPrice) {
      return;
    }

    const installmentTotalElement = installments.querySelector('.product-info__installments-total');
    if (installmentTotalElement) {
      installmentTotalElement.textContent = formatMoney(installmentPrice / 4);
    }

    const variantId = variant?.id || installments.querySelector('payment-terms [name="id"]')?.value || installments.querySelector('shopify-payment-terms')?.getAttribute('variant-id');
    replaceKlarnaPlacement(installments, installmentPrice);

    updateShopPayPaymentTerms(installments, installmentPrice, variantId);
  });

  refreshKlarnaPlacements();
}

function replaceKlarnaPlacement(installments, installmentPrice) {
  const klarnaPlacement = installments.querySelector('klarna-placement');

  if (!klarnaPlacement) {
    return;
  }

  const purchaseAmount = String(Math.round(installmentPrice));

  if (
    klarnaPlacement.dataset.anniversaryPurchaseAmount === purchaseAmount &&
    klarnaPlacement.getAttribute('data-purchase-amount') === purchaseAmount
  ) {
    return;
  }

  const replacement = document.createElement('klarna-placement');

  Array.from(klarnaPlacement.attributes).forEach((attribute) => {
    if (attribute.name !== 'data-purchase-amount') {
      replacement.setAttribute(attribute.name, attribute.value);
    }
  });

  replacement.setAttribute('data-purchase-amount', purchaseAmount);
  replacement.dataset.anniversaryPurchaseAmount = purchaseAmount;
  replacement.innerHTML = '<span></span>';

  klarnaPlacement.replaceWith(replacement);
}

function refreshKlarnaPlacements() {
  window.Klarna?.OnsiteMessaging?.refresh?.();

  window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
  window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
}

function updateShopPayPaymentTerms(installments, installmentPrice, variantId) {
  const shopPayTerms = installments.querySelector('shopify-payment-terms');

  if (!shopPayTerms) {
    return;
  }

  if (variantId) {
    shopPayTerms.setAttribute('variant-id', variantId);
  }

  const shopifyMeta = shopPayTerms.getAttribute('shopify-meta');

  if (!shopifyMeta) {
    return;
  }

  try {
    const meta = JSON.parse(shopifyMeta);
    const formattedFullPrice = formatMoney(installmentPrice);
    const formattedPricePerTerm = formatMoney(installmentPrice / 4);

    if (Array.isArray(meta.variants)) {
      meta.variants = meta.variants.map((variantMeta) => {
        if (variantId && String(variantMeta.id) !== String(variantId)) {
          return variantMeta;
        }

        return {
          ...variantMeta,
          full_price: formattedFullPrice,
          price_per_term: formattedPricePerTerm,
          number_of_payment_terms: 4
        };
      });
    }

    shopPayTerms.setAttribute('shopify-meta', JSON.stringify(meta));
  } catch (error) {
    console.warn('Unable to update Shop Pay installment metadata', error);
  }
}

/* Klarna and ShopPay */
document.addEventListener('DOMContentLoaded', function() {
  const interval = setInterval(() => {
    const shopPayEl = document.querySelector('shopify-payment-terms');
    const klarnaEl = document.querySelector('klarna-placement');

    if (shopPayEl && shopPayEl.shadowRoot && klarnaEl && klarnaEl.shadowRoot) {
      const shopPayMessage = shopPayEl.shadowRoot.querySelector('#shopify-installments-content');

      if (shopPayMessage) {
        shopPayMessage.style.display = "none";

        shopPayEl.style.display = "flex";
        klarnaEl.style.display = "flex";
        updateInstallmentWidgets();

        clearInterval(interval);
      }
    }
  }, 200);
});


// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}





/* A11y fixes */
document.addEventListener('DOMContentLoaded', function () {

  /* Caption issue fix */
  document.querySelectorAll('video[muted], video[loop], video[autoplay]').forEach(video => {
    video.setAttribute('aria-hidden', 'true');
  });



  /* Adding missing 'role' attribute on the Stockist page /pages/store-locator */
  const stockistWidget = document.querySelector('#stockist-widget')
  if (stockistWidget) {
    const searchField = stockistWidget.querySelector('.stockist-search-field')
    if (searchField) {
      searchField.setAttribute('role', 'combobox')
    }
  }



  /* Skip next fixes if it's not a Shogun page */
  if (!document.querySelector('.shogun-root')) return;

  /* Missing label on forms */
  document.querySelectorAll('.shogun-form-text-input, .shogun-form-textarea').forEach(wrapper => {
    const input = wrapper.querySelector('input, textarea');
    const label = wrapper.querySelector('label');

    if (input && label && !label.htmlFor) {
      label.setAttribute('for', input.id);
    }
  });

});

